import React, { useState } from 'react';
import { formatCurrencyUnit, formatStat } from '../../utils/formatters';

export function MonthlyPerformanceAccordion({ monthlyPerformanceData }) {
  const [activePlatform, setActivePlatform] = useState('Google Ads');

  if (!monthlyPerformanceData) {
    return <p className="text-xs text-gray-400 text-center py-4">No monthly data available</p>;
  }

  const platforms = ['Google Ads', 'Meta Ads'].filter(p => monthlyPerformanceData[p]);
  const data = monthlyPerformanceData[activePlatform];
  const months = data?.months || [];
  const totals = data?.totals || {};

  return (
    <div>
      <div className="flex gap-2 mb-3">
        {platforms.map(p => (
          <button
            key={p}
            onClick={() => setActivePlatform(p)}
            className={`pill-tab text-xs ${activePlatform === p ? 'pill-tab-active' : ''}`}
          >
            {p}
          </button>
        ))}
      </div>

      <div className="overflow-x-auto">
        <table className="modern-table w-full">
          <thead>
            <tr>
              <th className="text-left">Month</th>
              <th className="text-right">Cost</th>
              <th className="text-right">Clicks</th>
              <th className="text-right">Conv.</th>
              <th className="text-right">Revenue</th>
              <th className="text-right">Sessions</th>
              <th className="text-right">GA4 Rev</th>
              <th className="text-right">CPC</th>
              <th className="text-right">ROAS</th>
              <th className="text-right">GA4 ROAS</th>
            </tr>
          </thead>
          <tbody>
            {months.map((m, i) => (
              <tr key={i}>
                <td className="text-xs font-medium text-gray-700 whitespace-nowrap">{m.month}</td>
                <td className="text-right text-xs">{formatCurrencyUnit(m.cost)}</td>
                <td className="text-right text-xs">{formatStat(m.clicks)}</td>
                <td className="text-right text-xs">{formatStat(m.conversions)}</td>
                <td className="text-right text-xs font-medium">{formatCurrencyUnit(m.revenue)}</td>
                <td className="text-right text-xs">{formatStat(m.ga4_sessions)}</td>
                <td className="text-right text-xs font-medium">{formatCurrencyUnit(m.ga4_total_revenue)}</td>
                <td className="text-right text-xs">{formatCurrencyUnit(m.cpc)}</td>
                <td className="text-right text-xs">
                  <span className={m.roas >= 2 ? 'text-emerald-600 font-semibold' : 'text-gray-600'}>
                    {m.roas.toFixed(2)}x
                  </span>
                </td>
                <td className="text-right text-xs">
                  <span className={m.ga4_roas >= 2 ? 'text-emerald-600 font-semibold' : 'text-gray-600'}>
                    {m.ga4_roas.toFixed(2)}x
                  </span>
                </td>
              </tr>
            ))}
            <tr className="font-bold bg-gray-50/50">
              <td className="text-xs font-bold">Total</td>
              <td className="text-right text-xs font-bold">{formatCurrencyUnit(totals.cost)}</td>
              <td className="text-right text-xs font-bold">{formatStat(totals.clicks)}</td>
              <td className="text-right text-xs font-bold">{formatStat(totals.conversions)}</td>
              <td className="text-right text-xs font-bold">{formatCurrencyUnit(totals.revenue)}</td>
              <td className="text-right text-xs font-bold">{formatStat(totals.ga4_sessions)}</td>
              <td className="text-right text-xs font-bold">{formatCurrencyUnit(totals.ga4_total_revenue)}</td>
              <td className="text-right text-xs font-bold">{formatCurrencyUnit(totals.cpc)}</td>
              <td className="text-right text-xs font-bold">{(totals.roas || 0).toFixed(2)}x</td>
              <td className="text-right text-xs font-bold">{(totals.ga4_roas || 0).toFixed(2)}x</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
